import axios from "axios";

import { fetcher } from "#app/http/fetcher";
import { createFileHash } from "#modules/parts/domain/createFileHash";
import { FileTypeType } from "shared";

const axiosInstance = axios.create();

export const uploadFile = async ({
  file,
  callback,
  type,
  dangerousFolderPathOverride,
  isUserConnected,
}: {
  file: File;
  callback?: (progress: number) => void;
  type: FileTypeType;
  dangerousFolderPathOverride?: string;
  isUserConnected: boolean;
}): Promise<{ id: string; fileUrl: string }> => {
  const url = `/files${isUserConnected ? "" : "/public"}/upload-url`;

  const {
    data: { presignedUrl, id, url: fileUrl },
  } = await fetcher.post<{ id: string; url: string; presignedUrl: string | null }>(url, {
    s: file.size,
    m: file.type,
    t: type,
    h: await createFileHash(file),
    fileName: file.name,
    dangerousFolderPathOverride,
  });

  const formData = new FormData();
  formData.append("file", file);

  if (!presignedUrl) {
    return { id, fileUrl };
  }

  await axiosInstance.put(presignedUrl, file, {
    headers: {},
    onUploadProgress: function (progressEvent) {
      if (!progressEvent.total) {
        return undefined;
      }

      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      callback?.(percentCompleted);
    },
  });

  return {
    id,
    fileUrl,
  };
};
